import type { AppModule } from '@shared/presentation/router/composition.js';

export const homeModule: AppModule = {
  name: 'home',
  routes: [],
  layoutRoutes: [
    {
      path: '',
      name: 'home',
      component: () => import('./presentation/HomeView.vue'),
    },
  ],
};
